// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import { combineReducers } from 'redux';
import { get, post } from '../../shared/http/request';
import { handleApiError } from '../../shared/http/error';
import { ABNORMALITIES } from '../../constants';

/** **********************************
 * Abnormality analysis redux bundle *
 *********************************** */
// API
const BASE_URL = '/api/abnormalities/';
const COMMAND_URL = '/api/command/';

// Actions
const LOAD_ABNORMALITY_PENDING = 'LOAD_ABNORMALITY_PENDING';
const LOAD_ABNORMALITY_FULFILLED = 'LOAD_ABNORMALITY_FULFILLED';
const LOAD_ABNORMALITY_REJECTED = 'LOAD_ABNORMALITY_REJECTED';
const LOAD_GENERIC_MANIFESTS_PENDING = 'LOAD_GENERIC_MANIFESTS_PENDING';
const LOAD_GENERIC_MANIFESTS_FULFILLED = 'LOAD_GENERIC_MANIFESTS_FULFILLED';
const LOAD_GENERIC_MANIFESTS_REJECTED = 'LOAD_GENERIC_MANIFESTS_REJECTED';
const CREATE_ABNORMALITY_PENDING = 'CREATE_ABNORMALITY_PENDING';
const CREATE_ABNORMALITY_FULFILLED = 'CREATE_ABNORMALITY_FULFILLED';
const CREATE_ABNORMALITY_REJECTED = 'CREATE_ABNORMALITY_REJECTED';
const EDIT_ABNORMALITY_PENDING = 'EDIT_ABNORMALITY_PENDING';
const EDIT_ABNORMALITY_FULFILLED = 'EDIT_ABNORMALITY_FULFILLED';
const EDIT_ABNORMALITY_REJECTED = 'EDIT_ABNORMALITY_REJECTED';
const ASSIGN_ABNORMALITY_PENDING = 'ASSIGN_ABNORMALITY_PENDING';
const ASSIGN_ABNORMALITY_FULFILLED = 'ASSIGN_ABNORMALITY_FULFILLED';
const ASSIGN_ABNORMALITY_REJECTED = 'ASSIGN_ABNORMALITY_REJECTED';
const CANCEL_ABNORMALITY_PENDING = 'CANCEL_ABNORMALITY_PENDING';
const CANCEL_ABNORMALITY_FULFILLED = 'CANCEL_ABNORMALITY_FULFILLED';
const CANCEL_ABNORMALITY_REJECTED = 'CANCEL_ABNORMALITY_REJECTED';
const CLOSE_ABNORMALITY_PENDING = 'CLOSE_ABNORMALITY_PENDING';
const CLOSE_ABNORMALITY_FULFILLED = 'CLOSE_ABNORMALITY_FULFILLED';
const CLOSE_ABNORMALITY_REJECTED = 'CLOSE_ABNORMALITY_REJECTED';
const REMOVE_ABNORMALITY_TOASTR_FULFILLED = 'REMOVE_ABNORMALITY_TOASTR_FULFILLED';
const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
const LOAD_ATTACHMENTS_FULFILLED = 'LOAD_ATTACHMENTS_FULFILLED';
const LOAD_ATTACHMENTS_PENDING = 'LOAD_ATTACHMENTS_PENDING';
const LOAD_ATTACHMENTS_REJECTED = 'LOAD_ATTACHMENTS_REJECTED';

// Reducers
const entities = (state = null, action) => {
    switch (action.type) {
        case LOAD_ABNORMALITY_FULFILLED:
            const abnormalityById = [{ [action.abnormality.abnormalityId]: action.abnormality }];
            return Object.assign({}, state, ...abnormalityById);
        case LOAD_GENERIC_MANIFESTS_FULFILLED:
            return Object.assign({}, state, action.manifests);
        case CREATE_ABNORMALITY_FULFILLED: // {"status":"CONFIRMED","id":"310644fa-6159-497b-884e-538c8dff5024","message":"Successfully added a new blowout"}
        case EDIT_ABNORMALITY_FULFILLED: // some message?
        case CANCEL_ABNORMALITY_FULFILLED: // some message?
        case CLOSE_ABNORMALITY_FULFILLED: // some message?
        default:
            return state;
    }
};

const toastrs = (state = null, action) => {
    switch (action.type) {
        case CREATE_ABNORMALITY_FULFILLED: // TODO: (later) same for edit, cancel, close abnormality
            const clonedAction = Object.assign({}, action);
            clonedAction.response.type = 'create_blowout_abnormality';
            const toastrsById = [{ [clonedAction.response.id]: clonedAction.response }];
            return Object.assign({}, state, ...toastrsById);

        case REMOVE_ABNORMALITY_TOASTR_FULFILLED: // TODO: immutability ok??
            Object.assign(state[action.id], undefined);
            delete state[action.id];
            return state;

        default:
            return state;
    }
};

const recentlyUpdated = (state = null, action) => {
    switch (action.type) {
        case EDIT_ABNORMALITY_FULFILLED:
        case CREATE_ABNORMALITY_FULFILLED:
            const obj = [{ id: action.response.id }];
            return Object.assign({}, state, ...obj);
        case LOAD_ABNORMALITY_FULFILLED:
            return null;
        default:
            return state;
    }
};

const isFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_ABNORMALITY_PENDING:
            return true;
        case LOAD_ABNORMALITY_FULFILLED:
        case LOAD_ABNORMALITY_REJECTED:
            return false;
        default:
            return state;
    }
};

const isFetchingGenericManifests = (state = false, action) => {
    switch (action.type) {
        case LOAD_GENERIC_MANIFESTS_PENDING:
            return true;
        case LOAD_GENERIC_MANIFESTS_FULFILLED:
        case LOAD_GENERIC_MANIFESTS_REJECTED:
            return false;
        default:
            return state;
    }
};

const isPending = (state = false, action) => {
    switch (action.type) {
        case CREATE_ABNORMALITY_PENDING:
        case CANCEL_ABNORMALITY_PENDING:
        case CLOSE_ABNORMALITY_PENDING:
        case EDIT_ABNORMALITY_PENDING:
        case ASSIGN_ABNORMALITY_PENDING:
            return true;
        case CREATE_ABNORMALITY_FULFILLED:
        case CREATE_ABNORMALITY_REJECTED:
        case CANCEL_ABNORMALITY_FULFILLED:
        case CANCEL_ABNORMALITY_REJECTED:
        case CLOSE_ABNORMALITY_FULFILLED:
        case CLOSE_ABNORMALITY_REJECTED:
        case EDIT_ABNORMALITY_FULFILLED:
        case EDIT_ABNORMALITY_REJECTED:
        case ASSIGN_ABNORMALITY_FULFILLED:
        case ASSIGN_ABNORMALITY_REJECTED:
            return false;
        default:
            return state;
    }
};

const error = (state = null, action) => {
    switch (action.type) {
        case CREATE_ABNORMALITY_REJECTED:
        case EDIT_ABNORMALITY_REJECTED:
        case CANCEL_ABNORMALITY_REJECTED:
        case CLOSE_ABNORMALITY_REJECTED:
        case ASSIGN_ABNORMALITY_REJECTED:
        case LOAD_ABNORMALITY_REJECTED:
            return true;
        case LOAD_ABNORMALITY_PENDING:
        case LOAD_ABNORMALITY_FULFILLED:
        case CREATE_ABNORMALITY_PENDING:
        case CREATE_ABNORMALITY_FULFILLED:
        case CANCEL_ABNORMALITY_PENDING:
        case CANCEL_ABNORMALITY_FULFILLED:
        case CLOSE_ABNORMALITY_PENDING:
        case CLOSE_ABNORMALITY_FULFILLED:
        case EDIT_ABNORMALITY_PENDING:
        case EDIT_ABNORMALITY_FULFILLED:
        case ASSIGN_ABNORMALITY_FULFILLED:
        case ASSIGN_ABNORMALITY_PENDING:
            return false;
        default:
            return state;
    }
};

const errorMessage = (state = null, action) => {
    switch (action.type) {
        case LOAD_ABNORMALITY_REJECTED:
        case CREATE_ABNORMALITY_REJECTED:
        case CANCEL_ABNORMALITY_REJECTED:
        case CLOSE_ABNORMALITY_REJECTED:
        case EDIT_ABNORMALITY_REJECTED:
        case ASSIGN_ABNORMALITY_REJECTED:
            return action.message;
        case LOAD_ABNORMALITY_PENDING:
        case LOAD_ABNORMALITY_FULFILLED:
        case CREATE_ABNORMALITY_PENDING:
        case CREATE_ABNORMALITY_FULFILLED:
        case CANCEL_ABNORMALITY_PENDING:
        case CANCEL_ABNORMALITY_FULFILLED:
        case CLOSE_ABNORMALITY_PENDING:
        case CLOSE_ABNORMALITY_FULFILLED:
        case EDIT_ABNORMALITY_PENDING:
        case EDIT_ABNORMALITY_FULFILLED:
        case ASSIGN_ABNORMALITY_PENDING:
        case ASSIGN_ABNORMALITY_FULFILLED:
        case CLEAR_ERROR_MESSAGE:
            return null;
        default:
            return state;
    }
};

const attachments = (state = {}, action) => {
    switch (action.type) {
        case LOAD_ATTACHMENTS_FULFILLED:
            return Object.assign({}, state, action.attachments);
        default:
            return state;
    }
};

const attachmentsPending = (state = false, action) => {
    switch (action.type) {
        case LOAD_ATTACHMENTS_PENDING:
            return true;
        case LOAD_ATTACHMENTS_FULFILLED:
        case LOAD_ATTACHMENTS_REJECTED:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    entities,
    error,
    errorMessage,
    isFetching,
    isFetchingGenericManifests,
    isPending,
    recentlyUpdated,
    toastrs,
    attachments,
    attachmentsPending,
});

// Selectors
export const getAbnormalityById = (state, id) =>
    state.entities.abnormalities.entities ? state.entities.abnormalities.entities[id] : null;
export const getGenericManifests = state =>
    state.entities.abnormalities.entities ? state.entities.abnormalities.entities.manifests : null;
export const getIsFetching = state => state.entities.abnormalities.isFetching;
export const getIsFetchingGenericManifests = state =>
    state.entities.abnormalities.isFetchingGenericManifests;
export const getIsPending = state => state.entities.abnormalities.isPending;
export const getError = state => state.entities.abnormalities.error;
export const getErrorMessage = state => state.entities.abnormalities.errorMessage;
export const isRecentlyUpdated = state => state.entities.abnormalities.recentlyUpdated;
export const getAbnormalityToastrs = state => state.entities.abnormalities.toastrs;
export const getAbnormalityAttachments = (state, abnormalityId) =>
    Object.keys(state.entities.abnormalities.attachments).length > 0
        ? state.entities.abnormalities.attachments[abnormalityId]
        : [];
export const isAbnormalityAttachmentsPending = state =>
    state.entities.abnormalities.attachmentsPending;

// Action Creators/Thunks
export function createAbnormality(type, body) {
    return function(dispatch) {
        let endpoint;

        switch (type) {
            case ABNORMALITIES.BLOWOUT:
                endpoint = 'createBlowoutAbnormalityCommand';
                break;
            case ABNORMALITIES.DELAY:
                endpoint = 'createDelayAbnormalityCommand';
                break;
            case ABNORMALITIES.GENERIC:
                endpoint = 'createGenericAbnormalityCommand';
                break;
            case ABNORMALITIES.MISCOLLECTION:
                endpoint = 'createMisCollectionAbnormalityCommand';
                break;
            default:
                endpoint = null;
        }

        dispatch({ type: CREATE_ABNORMALITY_PENDING });

        return post(`${COMMAND_URL}${endpoint}`, body).then(
            response => dispatch({ type: CREATE_ABNORMALITY_FULFILLED, response }),
            error =>
                handleApiError(error, dispatch, {
                    type: CREATE_ABNORMALITY_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function editAbnormality(type, body) {
    return function(dispatch) {
        let endpoint;

        switch (type) {
            case ABNORMALITIES.BLOWOUT:
                endpoint = 'editBlowoutAbnormalityCommand';
                break;
            case ABNORMALITIES.DELAY:
                endpoint = 'editDelayAbnormalityCommand';
                break;
            case ABNORMALITIES.DAMAGE:
            case ABNORMALITIES.EARLY_FREIGHT:
            case ABNORMALITIES.LATE_FREIGHT:
            case ABNORMALITIES.INTERNAL_LOGISTICS:
            case ABNORMALITIES.NEW_ORDER:
            case ABNORMALITIES.RETURN_FREIGHT:
            case ABNORMALITIES.SHORT_SHIPMENT:
            case ABNORMALITIES.PARTIAL_SHORT_SHIPMENT:
            case ABNORMALITIES.UNABLE_TO_LOCATE:
                endpoint = 'editGenericAbnormalityCommand';
                break;
            case ABNORMALITIES.MISCOLLECTION:
                endpoint = 'editMisCollectionAbnormalityCommand';
                break;
            default:
                endpoint = null;
        }

        dispatch({ type: EDIT_ABNORMALITY_PENDING });

        return post(`${COMMAND_URL}${endpoint}`, body).then(
            response =>
                dispatch({
                    type: EDIT_ABNORMALITY_FULFILLED,
                    response,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: EDIT_ABNORMALITY_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function cancelAbnormality(body) {
    return function(dispatch) {
        dispatch({ type: CANCEL_ABNORMALITY_PENDING });

        return post(`${COMMAND_URL}cancelAbnormalityCommand`, body).then(
            response => dispatch({ type: CANCEL_ABNORMALITY_FULFILLED, response }),
            error =>
                handleApiError(error, dispatch, {
                    type: CANCEL_ABNORMALITY_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function closeAbnormality(body) {
    return function(dispatch) {
        dispatch({ type: CLOSE_ABNORMALITY_PENDING });

        return post(`${COMMAND_URL}closeAbnormalityCommand`, body).then(
            response => dispatch({ type: CLOSE_ABNORMALITY_FULFILLED, response }),
            error =>
                handleApiError(error, dispatch, {
                    type: CLOSE_ABNORMALITY_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadAbnormality(abnormalityId) {
    return function(dispatch) {
        dispatch({ type: LOAD_ABNORMALITY_PENDING });

        return get(`${BASE_URL}${abnormalityId}`).then(
            response =>
                dispatch({
                    type: LOAD_ABNORMALITY_FULFILLED,
                    abnormality: response,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_ABNORMALITY_REJECTED,
                    message: error.message,
                })
        );
    };
}
// Action Creators/Thunks
export function loadGenericManifests(id, manifestBased) {
    return function(dispatch) {
        dispatch({ type: LOAD_GENERIC_MANIFESTS_PENDING });

        return get(
            `${BASE_URL}generic/manifests/${manifestBased ? 'manifest-based' : 'run-based'}/${id}`
        ).then(
            manifests => dispatch({ type: LOAD_GENERIC_MANIFESTS_FULFILLED, manifests }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_GENERIC_MANIFESTS_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function assignAbnormalityToMe(id) {
    return function(dispatch) {
        dispatch({ type: ASSIGN_ABNORMALITY_PENDING });

        return post(`${COMMAND_URL}/assignAbnormalityToMeCommand`, {
            abnormalityId: id,
        }).then(
            response => {
                setTimeout(
                    () =>
                        dispatch({
                            type: ASSIGN_ABNORMALITY_FULFILLED,
                            response,
                        }),
                    500
                );
                // dispatch(loadAbnormality(id));
            },
            error =>
                handleApiError(error, dispatch, {
                    type: ASSIGN_ABNORMALITY_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function removeAbnormalityToastr(toastrId) {
    return function(dispatch) {
        dispatch({ type: REMOVE_ABNORMALITY_TOASTR_FULFILLED, id: toastrId });
    };
}

export function clearErrorMessage() {
    return function(dispatch) {
        dispatch({ type: CLEAR_ERROR_MESSAGE });
    };
}

export function loadAbnormalityFiles(abnormalityId) {
    return function(dispatch) {
        dispatch({ type: LOAD_ATTACHMENTS_PENDING });

        return get(`/api/files/abnormality/${abnormalityId}`).then(response => {
            dispatch({
                type: LOAD_ATTACHMENTS_FULFILLED,
                attachments: {
                    [response.abnormalityId]: response.files,
                },
            });
        });
    };
}
